import { render, staticRenderFns } from "./Pediatria.vue?vue&type=template&id=0f3a2982&scoped=true&"
import script from "./Pediatria.vue?vue&type=script&lang=js&"
export * from "./Pediatria.vue?vue&type=script&lang=js&"
import style0 from "./Pediatria.vue?vue&type=style&index=0&id=0f3a2982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3a2982",
  null
  
)

export default component.exports